import { render, staticRenderFns } from "./quickForm.vue?vue&type=template&id=18af4a5c&scoped=true&lang=html&"
import script from "./quickForm.vue?vue&type=script&lang=js&"
export * from "./quickForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18af4a5c",
  null
  
)

export default component.exports